<template>
  <div class="main-content">
    <!-- 检索过滤区域 -->
    <div class="search-wrapper marginBottom20">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- 课程包标题 -->
        <el-form-item label="课程包标题 :">
          <el-input
            v-model="searchData.title"
            placeholder="请输入课程包标题"
            clearable
            maxlength="100"
            style="width: 240px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <!-- 所属分类 -->
        <el-form-item label="所属分类 :">
          <el-select
            v-model="searchData.classifyId"
            placeholder="全部分类"
            clearable
            style="width: 200px"
          >
            <el-option
              v-for="item in classifyOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 上架状态 -->
        <el-form-item label="上架状态 :">
          <el-select
            v-model="searchData.state"
            placeholder="全部状态"
            clearable
            style="width: 150px"
          >
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <!-- 按钮区 -->
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearch"
            >查询</el-button
          >
          <el-button size="medium" icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格上方的操作栏 -->
    <div class="action-bar marginBottom20 flex justify-between align-center">
      <div class="page-title">课程包管理</div>
      <el-button
        size="medium"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        新增课程包
      </el-button>
    </div>

    <!-- 数据列表表格 -->
    <div class="table-container">
      <el-table
        v-loading="showLoading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <!-- 课程包封面 -->
        <el-table-column label="课程包封面" width="130" align="center">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.cover"
              style="width: 90px; height: 50px; border-radius: 4px"
              :src="row.cover"
              :preview-src-list="[row.cover]"
              fit="cover"
            >
              <div
                slot="error"
                class="image-slot flex align-center justify-center"
              >
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <span v-else>—</span>
          </template>
        </el-table-column>

        <!-- 课程包标题 -->
        <el-table-column
          prop="title"
          label="课程包标题"
          min-width="180"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <span class="package-title">{{ row.title }}</span>
          </template>
        </el-table-column>

        <!-- 副标题 -->
        <el-table-column
          prop="subtitle"
          label="副标题"
          min-width="160"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <span class="package-subtitle">{{ row.subtitle || "-" }}</span>
          </template>
        </el-table-column>

        <!-- 所属分类 -->
        <el-table-column
          prop="classifyName"
          label="所属分类"
          width="150"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.classifyName || "—" }}</span>
          </template>
        </el-table-column>

        <!-- 上架状态 -->
        <el-table-column label="上架状态" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.state"
              :active-value="1"
              :inactive-value="2"
              @change="handleStateChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <!-- 排序 -->
        <el-table-column prop="sort" label="排序" width="90" align="center">
        </el-table-column>

        <!-- 首页推荐 -->
        <el-table-column label="首页推荐" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isHome"
              :active-value="1"
              :inactive-value="2"
              @change="handleHomeChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              class="action-btn btn-edit"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-delete"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-container marginTop20 flex justify-end">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      >
      </el-pagination>
    </div>

    <!-- 新增/修改大弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      :title="form.id ? '编辑课程包' : '新增课程包'"
      :visible.sync="dialogVisible"
      width="780px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="package-dialog"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="formRules"
        label-width="110px"
        size="medium"
        style="padding: 0 10px"
      >
        <!-- 基本属性 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="课程包标题" prop="title">
              <el-input
                v-model="form.title"
                maxlength="100"
                placeholder="请输入课程包标题"
                clearable
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="副标题" prop="subtitle">
              <el-input
                v-model="form.subtitle"
                maxlength="100"
                placeholder="请输入副标题"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属分类" prop="classifyId">
              <el-select
                v-model="form.classifyId"
                placeholder="请选择分类"
                style="width: 100%"
              >
                <el-option
                  v-for="item in classifyOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序值" prop="sort">
              <el-input-number
                v-model="form.sort"
                :min="1"
                :max="9999"
                controls-position="right"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="课程包封面" prop="cover">
              <FormImgUpload
                :url="form.cover ? [form.cover] : []"
                :limit="1"
                :maxSize="5"
                accept=".png,.jpg,.jpeg"
                @upload="handleCoverUpload"
              />
              <div class="upload-tip">
                建议尺寸 273*154px，支持 JPG/PNG，大小不超过 5MB
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="课程包介绍" prop="intro">
              <el-input
                type="textarea"
                v-model="form.intro"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入课程包介绍"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="上架状态" prop="state">
              <el-radio-group v-model="form.state">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="2">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首页推荐" prop="isHome">
              <el-radio-group v-model="form.isHome">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 学习路径编排卡片 -->
        <div class="step-编排-container">
          <div class="编排-header flex justify-between align-center">
            <span class="编排-title"
              >学习路径编排 <span class="required-star">*</span></span
            >
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="handleAddStep"
              >添加Step</el-button
            >
          </div>

          <!-- 无Step数据时的提示 -->
          <div
            v-if="form.subList.length === 0"
            class="empty-step-box flex align-center justify-center"
          >
            <div class="text-center">
              <i class="el-icon-folder-opened empty-icon"></i>
              <p class="empty-text">
                当前暂未添加任何步骤，请点击“添加Step”按钮开始编排学习路径。
              </p>
            </div>
          </div>

          <!-- 步骤面板列表 -->
          <div v-else class="step-list">
            <draggable
              v-model="form.subList"
              handle=".drag-step-handle"
              animation="300"
            >
              <div
                v-for="(step, index) in form.subList"
                :key="step.keyId || step.id || index"
                class="step-card marginBottom15"
              >
                <!-- 步骤头 -->
                <div class="step-card-header flex justify-between align-center">
                  <div
                    class="step-title-wrapper flex align-center"
                    style="flex: 1; margin-right: 20px"
                  >
                    <i class="el-icon-rank drag-icon drag-step-handle"></i>
                    <span class="step-index-badge">Step {{ index + 1 }}</span>
                    <template v-if="step.isEditingTitle">
                      <el-input
                        v-model="step.title"
                        size="mini"
                        placeholder="请输入步骤标题"
                        style="width: 240px"
                        @blur="step.isEditingTitle = false"
                        @keyup.enter.native="step.isEditingTitle = false"
                        @click.stop.native
                      ></el-input>
                    </template>
                    <template v-else>
                      <span
                        class="step-display-title"
                        style="cursor: pointer"
                        title="点击编辑"
                        @click="step.isEditingTitle = true"
                        >{{ step.title || "未命名步骤" }}</span
                      >
                      <el-button
                        type="text"
                        icon="el-icon-edit"
                        style="margin-left: 8px; padding: 0; color: #0a7636"
                        @click="step.isEditingTitle = true"
                      ></el-button>
                    </template>
                  </div>
                  <div class="step-actions flex align-center">
                    <!-- 上移 -->
                    <el-button
                      type="text"
                      icon="el-icon-caret-top"
                      :disabled="index === 0"
                      @click="moveStep(index, 'up')"
                      >上移</el-button
                    >
                    <!-- 下移 -->
                    <el-button
                      type="text"
                      icon="el-icon-caret-bottom"
                      :disabled="index === form.subList.length - 1"
                      @click="moveStep(index, 'down')"
                      >下移</el-button
                    >
                    <!-- 删除步骤 -->
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      class="btn-delete-step"
                      @click="removeStep(index)"
                      >删除</el-button
                    >
                    <!-- 折叠控制 -->
                    <el-button
                      type="text"
                      :icon="
                        step.isCollapsed
                          ? 'el-icon-arrow-down'
                          : 'el-icon-arrow-up'
                      "
                      @click="step.isCollapsed = !step.isCollapsed"
                    >
                      {{ step.isCollapsed ? "展开" : "折叠" }}
                    </el-button>
                  </div>
                </div>

                <!-- 步骤体 -->
                <div v-show="!step.isCollapsed" class="step-card-body">
                  <!-- <el-form-item label="重点" style="margin-bottom: 15px">
                    <el-input
                      v-model="step.focus"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入本阶段重点"
                      maxlength="300"
                      show-word-limit
                    ></el-input>
                  </el-form-item> -->

                  <!-- <el-form-item
                    label="目标"
                    required
                    style="margin-bottom: 15px"
                  >
                    <el-input
                      v-model="step.target"
                      placeholder="请输入本阶段目标"
                      maxlength="100"
                      clearable
                    ></el-input>
                  </el-form-item> -->

                  <!-- 章节课程列表 -->
                  <el-form-item label="学习内容" required>
                    <div class="step-courses-wrapper">
                      <!-- 课程行列表 -->
                      <draggable
                        v-model="step.courseList"
                        handle=".drag-course-handle"
                        animation="300"
                      >
                        <div
                          v-for="(cItem, cIdx) in step.courseList"
                          :key="cItem.courseId"
                          class="course-row-item flex justify-between align-center"
                        >
                          <div class="course-info flex align-center">
                            <i
                              class="el-icon-rank drag-icon drag-course-handle"
                            ></i>
                            <span class="course-title-text">{{
                              getCourseTitle(cItem.courseId) ||
                              cItem.name ||
                              "-"
                            }}</span>
                            <el-tag
                              size="mini"
                              type="info"
                              class="course-duration-tag"
                            >
                              {{
                                getCourseDurationText(
                                  cItem.courseId,
                                  cItem.duration
                                )
                              }}
                            </el-tag>
                          </div>
                          <div class="course-actions">
                            <el-button
                              type="text"
                              icon="el-icon-caret-top"
                              :disabled="cIdx === 0"
                              @click="moveCourse(step.courseList, cIdx, 'up')"
                            ></el-button>
                            <el-button
                              type="text"
                              icon="el-icon-caret-bottom"
                              :disabled="cIdx === step.courseList.length - 1"
                              @click="moveCourse(step.courseList, cIdx, 'down')"
                            ></el-button>
                            <el-button
                              type="text"
                              icon="el-icon-close"
                              class="btn-close-course"
                              @click="removeCourse(step.courseList, cIdx)"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </draggable>

                      <!-- 添加课程按钮 -->
                      <div
                        class="add-course-dashed-btn flex align-center justify-center"
                        @click="handleOpenAddCourse(index)"
                      >
                        <i class="el-icon-plus"></i>
                        <span>添加关联课程</span>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </el-form>

      <!-- 弹窗底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          :loading="showLoadingForm"
          size="medium"
          class="btn-submit"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择关联课程的多选 Dialog -->
    <el-dialog
      title="选择关联课程"
      :visible.sync="courseDialogVisible"
      width="700px"
      append-to-body
      class="course-select-dialog"
      @opened="onCourseDialogOpened"
    >
      <div class="dialog-search marginBottom15 flex align-center">
        <el-input
          v-model="courseSearchQuery"
          placeholder="搜索课程标题"
          size="small"
          prefix-icon="el-icon-search"
          clearable
          style="width: 200px; margin-right: 10px"
          @keyup.enter.native="handleDialogCourseSearch"
          @clear="handleDialogCourseSearch"
        ></el-input>
        <el-cascader
          v-model="dialogSearchClassifyIds"
          :options="dialogClassifyCascaderOptions"
          placeholder="课程分类"
          size="small"
          clearable
          change-on-select
          style="width: 200px; margin-right: 10px"
          @change="handleDialogCourseSearch"
        ></el-cascader>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="handleDialogCourseSearch"
          >查询</el-button
        >
      </div>

      <el-table
        ref="courseTable"
        v-loading="dialogCourseLoading"
        :data="dialogCourseList"
        row-key="id"
        border
        size="small"
        height="350px"
        style="width: 100%"
        @selection-change="handleCourseSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="课程标题"
          prop="title"
          min-width="200"
          header-align="center"
          align="left"
        ></el-table-column>
        <el-table-column label="分类" width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ getClassifyFormat(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="视频时长" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ getCourseDurationText(row.id, row.duration) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上架状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.state === 1" type="success" size="mini"
              >已上架</el-tag
            >
            <el-tag v-else-if="row.state === 2" type="danger" size="mini"
              >已下架</el-tag
            >
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleDialogCourseSizeChange"
        @current-change="handleDialogCourseCurrentChange"
        :current-page="dialogCoursePage.current"
        :page-sizes="[10, 20, 50]"
        :page-size="dialogCoursePage.size"
        layout="total, sizes, prev, pager, next"
        :total="dialogCoursePage.total"
        style="margin-top: 15px; text-align: right"
      >
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="courseDialogVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="confirmAddCourses"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  coursePackageList,
  coursePackageAdd,
  coursePackageUpdate,
  coursePackageDelete,
  coursePackageStateUpdate,
  coursePackageHomeUpdate,
  coursePackageDetail,
} from "@/api/course/package";
import { coursePackageClassifyListAll } from "@/api/course/packageClassify";
import { courseInfoListAll, courseInfoList } from "@/api/course/info";
import { courseClassifyListAll } from "@/api/course/classify";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import draggable from "vuedraggable";

export default {
  name: "CoursePackage",
  components: {
    FormImgUpload,
    draggable,
  },
  data() {
    return {
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      courseDialogVisible: false,
      currentStepIndex: null, // 当前正在为哪一步配课
      searchData: {
        title: "",
        classifyId: "",
        state: "",
      },
      classifyOptions: [], // 课程包分类
      allCoursesList: [], // 全量可选课程
      courseMap: {}, // 课程 id -> 课程对象映射
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      dialogCourseList: [], // 弹窗可选课程列表（分页）
      dialogCoursePage: {
        current: 1,
        size: 10,
        total: 0,
      },
      dialogCourseLoading: false, // 弹窗表格加载状态
      form: {
        id: "",
        title: "",
        subtitle: "",
        classifyId: "",
        sort: 1,
        cover: "",
        intro: "",
        state: 1,
        isHome: 2,
        subList: [],
      },
      formRules: {
        title: [
          { required: true, message: "请输入课程包标题", trigger: "blur" },
          { max: 100, message: "标题不能超过 100 个字符", trigger: "blur" },
        ],
        classifyId: [
          { required: true, message: "请选择所属分类", trigger: "change" },
        ],
        cover: [
          { required: true, message: "请上传课程包封面", trigger: "change" },
        ],
        sort: [{ required: true, message: "请输入排序值", trigger: "blur" }],
      },
      courseSearchQuery: "",
      dialogSearchClassifyIds: [], // 弹窗中选择的分类ID级联数组
      classifyTreeData: [], // 课程分类树数据
      allClassifyMap: {}, // 打平的课程分类ID-名称映射
      tempSelectedCourses: [], // 课程选择弹窗中当前勾选的课程行
      isLayoutSelection: false, // 是否正在程序化设置勾选状态，以避免触发 selection-change 清空数据
    };
  },
  computed: {
    // 弹窗课程过滤
    filteredCourses() {
      if (!this.courseSearchQuery) {
        return this.allCoursesList;
      }
      const q = this.courseSearchQuery.trim().toLowerCase();
      return this.allCoursesList.filter(
        (item) => item.title && item.title.toLowerCase().includes(q)
      );
    },
    // 将分类树格式化为 Cascader 级联选择器支持的结构
    dialogClassifyCascaderOptions() {
      const format = (list) => {
        return list.map((item) => {
          const hasChildren =
            Array.isArray(item.children) && item.children.length > 0;
          return {
            value: item.id,
            label: item.name,
            children: hasChildren ? format(item.children) : null,
          };
        });
      };
      return format(this.classifyTreeData);
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      this.showLoading = true;
      try {
        await Promise.all([
          this.getClassifyOptions(),
          this.getAllCoursesList(),
          this.getClassifyTree(),
        ]);
        this.onLoad();
      } catch (e) {
        console.error(e);
        this.showLoading = false;
      }
    },

    // 获取全量课程分类树
    async getClassifyTree() {
      try {
        const res = await courseClassifyListAll();
        if (res.code === 200 && Array.isArray(res.data)) {
          this.classifyTreeData = res.data;
          this.flattenClassify(res.data);
        }
      } catch (error) {
        console.error("加载分类数据失败:", error);
      }
    },

    // 打平分类树
    flattenClassify(tree) {
      const map = {};
      const traverse = (node) => {
        map[node.id] = node.name;
        if (Array.isArray(node.children) && node.children.length > 0) {
          node.children.forEach(traverse);
        }
      };
      tree.forEach(traverse);
      this.allClassifyMap = map;
    },

    // 格式化分类展示
    getClassifyFormat(row) {
      const first = this.allClassifyMap[row.firstLevelClassifyId];
      const second = this.allClassifyMap[row.secondLevelClassifyId];
      if (first && second) {
        return `${first} / ${second}`;
      }
      return first || second || row.classifyName || "—";
    },

    // 获取所有课程包分类
    async getClassifyOptions() {
      const res = await coursePackageClassifyListAll();
      if (res.code === 200 && Array.isArray(res.data)) {
        this.classifyOptions = res.data;
      }
    },

    // 获取全部课程
    async getAllCoursesList() {
      const res = await courseInfoListAll();
      if (res.code === 200 && Array.isArray(res.data)) {
        this.allCoursesList = res.data;
        const map = {};
        res.data.forEach((item) => {
          map[item.id] = item;
        });
        this.courseMap = map;
      }
    },

    // 加载列表数据
    onLoad() {
      this.showLoading = true;
      const params = {
        title: this.searchData.title ? this.searchData.title.trim() : undefined,
        classifyId: this.searchData.classifyId || undefined,
        state: this.searchData.state || undefined,
        page: this.page.current,
        size: this.page.size,
      };
      coursePackageList(params)
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200 && res.data) {
            this.tableData = res.data.records || [];
            this.page.total = Number(res.data.total) || 0;
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "—";
      try {
        const date = new Date(time);
        if (isNaN(date.getTime())) return time;
        const pad = (num) => String(num).padStart(2, "0");
        const y = date.getFullYear();
        const m = pad(date.getMonth() + 1);
        const d = pad(date.getDate());
        const h = pad(date.getHours());
        const min = pad(date.getMinutes());
        return `${y}-${m}-${d} ${h}:${min}`;
      } catch (e) {
        return time;
      }
    },

    // 查询
    handleSearch() {
      this.page.current = 1;
      this.onLoad();
    },

    // 重置
    handleReset() {
      this.searchData.title = "";
      this.searchData.classifyId = "";
      this.searchData.state = "";
      this.page.current = 1;
      this.onLoad();
    },

    // 每页条数切换
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.onLoad();
    },

    // 页码切换
    handleCurrentChange(val) {
      this.page.current = val;
      this.onLoad();
    },

    // 快捷切换启用/禁用上架状态
    handleStateChange(row) {
      const originalState = row.state === 1 ? 2 : 1;
      const stateText = row.state === 1 ? "上架" : "下架";

      coursePackageStateUpdate({
        id: row.id,
        state: row.state,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`${stateText}成功`);
            this.onLoad();
          } else {
            row.state = originalState;
          }
        })
        .catch(() => {
          row.state = originalState;
        });
    },

    // 快捷切换首页推荐
    handleHomeChange(row) {
      const originalIsHome = row.isHome === 1 ? 2 : 1;
      const homeText = row.isHome === 1 ? "推荐到首页" : "取消首页推荐";

      coursePackageHomeUpdate({
        id: row.id,
        isHome: row.isHome,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`已成功将课程包【${row.title}】${homeText}`);
            this.onLoad();
          } else {
            row.isHome = originalIsHome;
          }
        })
        .catch(() => {
          row.isHome = originalIsHome;
        });
    },

    // 封面上传
    handleCoverUpload(res) {
      if (Array.isArray(res)) {
        this.form.cover = res[0] || "";
      } else {
        this.form.cover = res || "";
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.validateField("cover");
      }
    },

    // 翻译显示课程名称
    getCourseTitle(courseId) {
      const course = this.courseMap[courseId];
      return course ? course.title : "";
    },

    /**
     * 翻译并格式化显示课程总时长
     * @param {string|number} courseId - 课程 ID
     * @param {number} [detailDuration] - 步骤中关联课程记录的时长属性
     * @returns {string} 格式化后的时长文本，例如 "时长 · 12:05" 或空字符串
     */
    getCourseDurationText(courseId, detailDuration) {
      const course = this.courseMap[courseId];
      let totalSec = 0;
      if (
        course &&
        Array.isArray(course.videoDetailList) &&
        course.videoDetailList.length > 0
      ) {
        totalSec = course.videoDetailList.reduce(
          (acc, cur) => acc + (cur.durationNum || cur.duration || 0),
          0
        );
      } else if (course && (course.duration || course.durationNum)) {
        totalSec = course.duration || course.durationNum;
      } else if (detailDuration) {
        totalSec = detailDuration;
      }

      if (totalSec > 0) {
        const m = Math.floor(totalSec / 60);
        const s = totalSec % 60;
        return `时长 · ${m}:${String(s).padStart(2, "0")}`;
      }
      return "";
    },

    // 编排 - 添加步骤
    handleAddStep() {
      this.form.subList.push({
        id: "",
        keyId:
          "step_" +
          Date.now() +
          "_" +
          Math.random().toString(36).substring(2, 9),
        title: "",
        target: "",
        focus: "",
        sort: this.form.subList.length + 1,
        isCollapsed: false,
        isEditingTitle: true,
        courseList: [],
      });
    },

    // 编排 - 移除步骤
    removeStep(index) {
      this.$confirm("确定要删除该步骤及里面配置的课程吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.form.subList.splice(index, 1);
        })
        .catch(() => {});
    },

    // 编排 - 移动步骤
    moveStep(index, direction) {
      const targetIndex = direction === "up" ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= this.form.subList.length) return;
      const temp = this.form.subList[index];
      this.$set(this.form.subList, index, this.form.subList[targetIndex]);
      this.$set(this.form.subList, targetIndex, temp);
    },

    // 编排 - 移动步骤内课程
    moveCourse(courseList, index, direction) {
      const targetIndex = direction === "up" ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= courseList.length) return;
      const temp = courseList[index];
      this.$set(courseList, index, courseList[targetIndex]);
      this.$set(courseList, targetIndex, temp);
    },

    // 编排 - 删除步骤内课程
    removeCourse(courseList, index) {
      courseList.splice(index, 1);
    },

    /**
     * 监听选择课程 Dialog 完全打开的事件，确保在 DOM 渲染就绪后执行勾选回显
     */
    onCourseDialogOpened() {
      this.$nextTick(() => {
        this.initTableSelection();
      });
    },

    /**
     * 初始化表格勾选回显。在更新选择状态时通过标志位屏蔽事件副作用，同时优先选择表格中的真实行对象进行勾选。
     */
    initTableSelection() {
      if (this.$refs.courseTable) {
        this.isLayoutSelection = true;
        const backup = [...this.tempSelectedCourses];

        // 清空状态
        this.$refs.courseTable.clearSelection();
        backup.forEach((row) => {
          // 优先寻找当前页中相同 id 的实际行对象以保证勾选动作及后续取消勾选能被 Element UI 正确捕捉
          const matchRow = this.dialogCourseList.find(
            (item) => item.id === row.id
          );
          if (matchRow) {
            this.$refs.courseTable.toggleRowSelection(matchRow, true);
          } else {
            this.$refs.courseTable.toggleRowSelection(row, true);
          }
        });

        // 重新设回正确的数据备份
        this.tempSelectedCourses = backup;

        // 延迟一个 tick 恢复标志位，防止同步触发后的其他微任务干扰变更记录
        this.$nextTick(() => {
          this.isLayoutSelection = false;
        });
      }
    },

    /**
     * 编排 - 打开加课弹窗并初始化已选数据
     * @param {number} stepIndex - 当前操作 of 步骤索引 (index)
     */
    async handleOpenAddCourse(stepIndex) {
      this.currentStepIndex = stepIndex;
      this.courseSearchQuery = "";
      this.dialogSearchClassifyIds = [];
      this.dialogCoursePage.current = 1;
      this.dialogCoursePage.size = 10;
      this.dialogCourseList = [];

      // 提取当前步骤已关联课程对应的全量对象，初始化 tempSelectedCourses
      // 合并步骤课程里的时长数据，防止 courseMap 中缺少此字段导致之后保存时时长丢失
      const selectedIds = this.form.subList[stepIndex].courseList.map(
        (c) => c.courseId
      );
      this.tempSelectedCourses = this.form.subList[stepIndex].courseList
        .map((c) => {
          const baseCourse = this.courseMap[c.courseId];
          if (baseCourse) {
            return {
              ...baseCourse,
              duration:
                c.duration || baseCourse.duration || baseCourse.durationNum,
            };
          }
          return null;
        })
        .filter(Boolean);

      this.courseDialogVisible = true;

      // 获取第一页数据
      await this.getDialogCourseList();

      // 使用 nextTick 在 DOM 渲染更新就绪后，执行勾选回显，防止被渲染时序重置
      this.$nextTick(() => {
        this.initTableSelection();
      });
    },

    /**
     * 分页获取弹窗课程列表，过滤已下架的数据
     * @returns {Promise<void>} 无返回值
     */
    async getDialogCourseList() {
      this.dialogCourseLoading = true;
      try {
        let firstId = "";
        let secondId = "";
        if (
          Array.isArray(this.dialogSearchClassifyIds) &&
          this.dialogSearchClassifyIds.length > 0
        ) {
          if (this.dialogSearchClassifyIds.length > 1) {
            firstId = this.dialogSearchClassifyIds[0];
            secondId = this.dialogSearchClassifyIds[1];
          } else {
            // 仅有一个 ID 时，智能解析它是属于一级还是二级
            const targetId = this.dialogSearchClassifyIds[0];
            const rootNode = this.classifyTreeData.find(
              (item) => item.id === targetId
            );
            if (rootNode) {
              firstId = targetId;
            } else {
              let foundParentId = "";
              for (const root of this.classifyTreeData) {
                if (Array.isArray(root.children)) {
                  const subNode = root.children.find(
                    (child) => child.id === targetId
                  );
                  if (subNode) {
                    foundParentId = root.id;
                  }
                }
              }
              if (foundParentId) {
                firstId = foundParentId;
                secondId = targetId;
              } else {
                firstId = targetId;
              }
            }
          }
        }

        const params = {
          title: this.courseSearchQuery
            ? this.courseSearchQuery.trim()
            : undefined,
          firstLevelClassifyId: firstId || undefined,
          secondLevelClassifyId: secondId || undefined,
          page: this.dialogCoursePage.current,
          size: this.dialogCoursePage.size,
          state: 1, // 过滤已下架的数据，仅获取已上架的数据
        };
        const res = await courseInfoList(params);
        if (res.code === 200 && res.data) {
          this.dialogCourseList = res.data.records || [];
          this.dialogCoursePage.total = Number(res.data.total) || 0;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.dialogCourseLoading = false;
      }
    },

    // 弹窗课程搜索
    handleDialogCourseSearch() {
      this.dialogCoursePage.current = 1;
      this.getDialogCourseList();
    },

    // 弹窗分页切换条数
    handleDialogCourseSizeChange(val) {
      this.dialogCoursePage.size = val;
      this.dialogCoursePage.current = 1;
      this.getDialogCourseList();
    },

    // 弹窗分页切换页码
    handleDialogCourseCurrentChange(val) {
      this.dialogCoursePage.current = val;
      this.getDialogCourseList();
    },

    /**
     * 响应课程选择弹窗中的多选状态变更
     * @param {Array} val - 当前所有被选中的行对象数组
     */
    handleCourseSelectionChange(val) {
      if (this.isLayoutSelection) return;
      this.tempSelectedCourses = val;
    },

    /**
     * 确认选择关联课程并保存到当前步骤
     */
    confirmAddCourses() {
      if (!this.tempSelectedCourses || this.tempSelectedCourses.length === 0) {
        this.$message.warning("请选择关联课程");
        return;
      }
      const targetStep = this.form.subList[this.currentStepIndex];
      targetStep.courseList = this.tempSelectedCourses.map((course, idx) => ({
        courseId: course.id,
        name: course.title || course.name,
        duration:
          course.duration ||
          course.durationNum ||
          (Array.isArray(course.videoDetailList)
            ? course.videoDetailList.reduce(
                (acc, cur) => acc + (cur.durationNum || cur.duration || 0),
                0
              )
            : undefined),
        sort: idx + 1,
      }));
      this.courseDialogVisible = false;
    },

    // 新增课程包点击
    handleCreate() {
      this.form = {
        id: "",
        title: "",
        subtitle: "",
        classifyId: "",
        sort: 1,
        cover: "",
        intro: "",
        state: 1,
        isHome: 2,
        subList: [],
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 编辑课程包点击
    async handleEdit(row) {
      this.showLoading = true;
      try {
        const res = await coursePackageDetail(row.id);
        this.showLoading = false;
        if (res.code === 200 && res.data) {
          const detail = res.data;
          if (detail) {
            this.form = {
              id: detail.id,
              title: detail.title,
              subtitle: detail.subtitle || "",
              classifyId: detail.classifyId || "",
              sort: detail.sort || 1,
              cover: detail.cover || "",
              intro: detail.intro || "",
              state: detail.state || 1,
              isHome: detail.isHome || 2,
              subList: Array.isArray(detail.subList)
                ? detail.subList.map((v) => ({
                    id: v.id,
                    keyId:
                      v.id ||
                      "step_" +
                        Date.now() +
                        "_" +
                        Math.random().toString(36).substring(2, 9),
                    title: v.title || "",
                    target: v.target || "",
                    focus: v.focus || "",
                    sort: v.sort || 1,
                    isCollapsed: false,
                    isEditingTitle: false,
                    courseList: Array.isArray(v.courseList)
                      ? v.courseList.map((c) => ({
                          courseId: c.id,
                          name: c.name,
                          duration: c.duration,
                          sort: c.sort || 1,
                        }))
                      : [],
                  }))
                : [],
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
              if (this.$refs.formRef) {
                this.$refs.formRef.clearValidate();
              }
            });
          } else {
            this.$message.error("未找到对应课程包数据");
          }
        }
      } catch (e) {
        console.error(e);
        this.showLoading = false;
      }
    },

    // 删除
    handleDelete(row) {
      this.$confirm(`确定要永久删除课程包【${row.title}】吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          coursePackageDelete(row.id).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.onLoad();
            }
          });
        })
        .catch(() => {});
    },

    // 关闭大弹窗
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        id: "",
        title: "",
        subtitle: "",
        classifyId: "",
        sort: 1,
        cover: "",
        intro: "",
        state: 1,
        isHome: 2,
        subList: [],
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },

    // 提交保存表单
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 校验编排逻辑
          if (this.form.subList.length === 0) {
            this.$message.warning("请添加至少一个学习路径步骤(Step)");
            return;
          }

          for (let i = 0; i < this.form.subList.length; i++) {
            const step = this.form.subList[i];
            if (!step.title || !step.title.trim()) {
              this.$message.warning(`请为 Step ${i + 1} 填写步骤标题`);
              return;
            }
            // if (!step.target || !step.target.trim()) {
            //   this.$message.warning(`请为 Step ${i + 1} 填写目标`);
            //   return;
            // }
            if (step.courseList.length === 0) {
              this.$message.warning(`Step ${i + 1} 还没有关联任何学习课程`);
              return;
            }
          }

          if (this.showLoadingForm) return;
          this.showLoadingForm = true;

          // 重新排序并清理前端字段
          const submitData = JSON.parse(JSON.stringify(this.form));
          submitData.title = submitData.title.trim();
          submitData.subtitle = submitData.subtitle
            ? submitData.subtitle.trim()
            : "";
          submitData.intro = submitData.intro ? submitData.intro.trim() : "";

          submitData.subList.forEach((step, stepIdx) => {
            step.sort = stepIdx + 1;
            step.title = step.title ? step.title.trim() : "";
            step.target = step.target ? step.target.trim() : "";
            delete step.isCollapsed; // 移除前端折叠辅助参数
            delete step.isEditingTitle; // 移除前端编辑标题辅助参数
            delete step.keyId; // 移除前端防重渲染的辅助参数
            step.courseList.forEach((course, courseIdx) => {
              course.sort = courseIdx + 1;
            });
          });

          const requestApi = submitData.id
            ? coursePackageUpdate
            : coursePackageAdd;

          requestApi(submitData)
            .then((res) => {
              this.showLoadingForm = false;
              if (res.code === 200) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                this.onLoad();
              }
            })
            .catch(() => {
              this.showLoadingForm = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 100px);
}

.action-bar {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.table-container {
  margin-top: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.package-title {
  font-weight: 500;
  color: #333333;
}

.package-subtitle {
  color: #666666;
  font-size: 13px;
}

/* 操作按钮 */
.action-btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0 10px;
  padding: 0;
  border: none;
}

.btn-delete {
  color: #ff001f !important;
}
.btn-delete:hover {
  color: #cc0018 !important;
  text-decoration: underline;
}

.upload-tip {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}

/* 编排区域 */
.step-编排-container {
  margin-top: 20px;
  border-top: 1px dashed #dcdfe6;
  padding-top: 20px;
}

.编排-header {
  margin-bottom: 15px;
}

.编排-title {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}

.required-star {
  color: #f56c6c;
  margin-left: 4px;
}

.empty-step-box {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  padding: 40px 20px;
  background-color: #fafafa;
}

.empty-icon {
  font-size: 36px;
  color: #c0c4cc;
}

.empty-text {
  font-size: 13px;
  color: #909399;
  margin-top: 10px;
}

/* 编排步骤卡片 */
.step-card {
  border: 1px solid #e0ebd8;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.step-card-header {
  background-color: #f4f9f6;
  padding: 10px 15px;
  border-bottom: 1px solid #e0ebd8;
}

.step-index-badge {
  background-color: #0a7636;
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  margin-right: 10px;
}

.step-display-title {
  font-size: 14px;
  font-weight: bold;
  color: #0a7636;
}

.step-actions .el-button {
  margin-left: 10px;
  font-size: 13px;
}

.btn-delete-step {
  color: #f56c6c !important;
}

.step-card-body {
  padding: 15px 20px;
  background-color: #ffffff;
}

/* 步骤关联课程部分 */
.step-courses-wrapper {
  background-color: #f9f9f9;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
}

.course-row-item {
  background-color: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  transition: all 0.3s;
}

.course-row-item:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.drag-icon {
  color: #909399;
  margin-right: 10px;
  font-size: 16px;
  cursor: move;
}

.course-title-text {
  font-size: 13px;
  color: #333333;
  font-weight: 500;
}

.course-duration-tag {
  margin-left: 10px;
}

.btn-close-course {
  color: #f56c6c !important;
  margin-left: 10px;
}

.add-course-dashed-btn {
  border: 1px dashed #c0d8c8;
  border-radius: 4px;
  padding: 10px;
  color: #0a7636;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s;
  background-color: #ffffff;
}

.add-course-dashed-btn:hover {
  background-color: #f0f7f3;
  border-color: #0a7636;
}

/* 间距辅助 */
.marginBottom15 {
  margin-bottom: 15px;
}
.marginBottom20 {
  margin-bottom: 20px;
}
.marginTop20 {
  margin-top: 20px;
}
.marginTop15 {
  margin-top: 15px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.justify-end {
  justify-content: flex-end;
}
.align-center {
  align-items: center;
}
</style>
